<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">2023-03-30</p>
    <div class="content">
      <!-- 第一段内容：获奖介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[0] || ''"></p>
        </div>
      </div>

      <!-- 图片1：朱佳敏总裁 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture1?.url">
          <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
        </div>
      </div>

      <!-- 第二段内容：榜单介绍 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[1] || ''"></p>
        </div>
      </div>

      <!-- 第三段内容：官方内容提示 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[2] || ''"></p>
        </div>
      </div>

      <!-- 第四段内容：入选理由与高亮 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="highlightText(currentNews.content?.split('---')[3] || '')"></p>
        </div>
      </div>

      <!-- 第五段内容：贡献详情1 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[4] || ''"></p>
        </div>
      </div>

      <!-- 图片2：官方报道 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture2?.url">
          <p class="image-caption">{{ currentNews.other?.picture2?.caption }}</p>
        </div>
      </div>

      <!-- 第六段内容：贡献详情2 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[5] || ''"></p>
        </div>
      </div>

      <!-- 第七段内容：贡献详情3 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[6] || ''"></p>
        </div>
      </div>

      <!-- 第八段内容：贡献详情4 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[7] || ''"></p>
        </div>
      </div>

      <!-- 第九段内容：重大工程 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[8] || ''"></p>
        </div>
      </div>

      <!-- 第十段内容：MIT-CFS合作 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[9] || ''"></p>
        </div>
      </div>

      <!-- 第十一段内容：国际领先地位 -->
      <div class="content-section">
        <div class="text-block">
          <p v-html="currentNews.content?.split('---')[10] || ''"></p>
        </div>
      </div>

      <!-- 图片3：合影 -->
      <div class="content-section image-section">
        <div class="image-container">
          <img :src="currentNews.other?.picture3?.url">
          <p class="image-caption">{{ currentNews.other?.picture3?.caption }}</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'keji35');
  return newsItem || {};
});

// 处理高亮文本的函数
const highlightText = (text: string) => {
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlighted-text">$1</span>');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto; 
}

.content-section {
  margin-bottom: 20px;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}

:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  background-color: transparent;
  padding: 2px 4px;
  border-radius: 3px;
}
</style> 